export default __webpack_public_path__ + "static/media/ethereum.adb79c18.png";